"use client";

import Link from "next/link";

import { appendQuery } from "@/app/(hire)/lib/return-to";
import { formMode } from "@/components/auth/form-mode";
import { authTestIds } from "@/lib/data-test-ids/components.data-test-ids";
import routes from "@/lib/routes";

const MODE_CONFIG = {
  [formMode.signin]: {
    promptText: "Don't have an account?",
    linkText: "Sign up",
    href: routes.getSignUp(),
    targetMode: formMode.signup,
    testId: authTestIds.MODAL_SIGN_UP_LINK,
  },
  [formMode.signup]: {
    promptText: "Already have an account?",
    linkText: "Sign in",
    href: routes.getSignIn(),
    targetMode: formMode.signin,
    testId: authTestIds.MODAL_SIGN_IN_LINK,
  },
} as const;

interface AuthModeSwitchProps {
  mode: formMode;
  query: string;
  onSwitch?: (newMode: formMode) => void;
}

export function AuthModeSwitch({ mode, query, onSwitch }: AuthModeSwitchProps) {
  const config = MODE_CONFIG[mode];

  return (
    <div className="text-center">
      <span className="text-xs sm:text-sm text-muted-foreground">
        {config.promptText}
      </span>{" "}
      {onSwitch ? (
        <button
          type="button"
          onClick={() => onSwitch(config.targetMode)}
          data-testid={config.testId}
          className="p-0 h-auto text-xs sm:text-sm text-secondary hover:text-secondary/80 font-semibold hover:underline"
        >
          {config.linkText}
        </button>
      ) : (
        <Link
          href={appendQuery(config.href, query)}
          className="p-0 h-auto text-xs sm:text-sm text-secondary hover:text-secondary/80 font-semibold hover:underline"
          data-testid={config.testId}
        >
          {config.linkText}
        </Link>
      )}
    </div>
  );
}
